import { render, staticRenderFns } from "./DeactivatedUsers.vue?vue&type=template&id=62800032&scoped=true"
import script from "./DeactivatedUsers.vue?vue&type=script&lang=js"
export * from "./DeactivatedUsers.vue?vue&type=script&lang=js"
import style0 from "./DeactivatedUsers.vue?vue&type=style&index=0&id=62800032&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62800032",
  null
  
)

export default component.exports